import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@web-shared/components/ui/tooltip";
import { setSurface } from "@web-shared/lib/api";
import { AccountApp } from "@/account/AccountApp";
import { ErrorBoundary } from "@/account/ErrorBoundary";
import "@/styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Everything here is a view of live backend state; a stale cache is
      // worse than a refetch.
      staleTime: 2_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

// One app per build now: this package is the account app, the admin visualizer
// is viz/. The surface the shared API client talks to is fixed for the life of
// the page.
setSurface("account");
// Nothing sets document.title here: index.html already carries the web app's
// title, rewritten per seed and per profile by the worker before the HTML
// leaves (worker/share-meta.ts). Setting it at boot threw that away; a page
// that wants a title of its own uses useDocumentTitle.

const root = document.getElementById("root");
if (!root) throw new Error("No #root element.");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={200}>
          <BrowserRouter>
            <AccountApp />
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
